// Logo: indigo speech bubble (highly rounded, tail bottom-left) with a white
// check inside and a mint notification dot top-right, plus the lowercase wordmark.

export function LogoMark({ size = 34, className = "" }) {
  const h = (size / 34) * 40;
  return (
    <svg
      width={size}
      height={h}
      viewBox="0 0 76 86"
      className={className}
      aria-hidden="true"
    >
      <g transform="translate(6,10)">
        <path
          d="M16 0 H40 A16 16 0 0 1 56 16 V40 A16 16 0 0 1 40 56 H28 L12 70 V56 A16 16 0 0 1 0 42 V16 A16 16 0 0 1 16 0 Z"
          fill="#4F46E5"
        />
        <path
          d="M16 29 L25 38 L41 20"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="5.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="53" cy="4" r="7.5" fill="#2BB693" stroke="#FFFFFF" strokeWidth="2.5" />
      </g>
    </svg>
  );
}

export function Logo({ variant = "dark", size = 30, className = "" }) {
  const isLight = variant === "light";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} />
      <span
        className="font-medium lowercase tracking-tight"
        style={{ fontSize: size * 0.58 }}
      >
        <span style={{ color: isLight ? "#FFFFFF" : "#1F2937" }}>asistentes</span>
        <span style={{ color: isLight ? "#A5B4FC" : "#4F46E5" }}>virtual</span>
        <span style={{ color: "#9CA3AF" }}>.com</span>
      </span>
    </span>
  );
}
